import {IQAEnvironmentPopUpBlockerService} from './qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.service.interface';
import {QAEnvironmentPopUpBlockerService} from './qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.service';
import {LiveStreamPlayingService} from './video-live-stream/live-stream-playing.service';
import {IVideoPlayingService} from './video-live-stream/video-playing.service.interface';
import {ITranslationService} from './translation/translation.service.interface';
import {TranslationService} from './translation/translation.service';
import {IGamesService} from './games/games.service.interface';
import {ILoggerService} from './logger/logger.service.interface';
import {ICurrencyService} from './currency/currency.service.interface';
import {CurrencyService} from './currency/currency.service';
import {IAnalyticsService} from './analytics/analytics.service.interface';
import {AnalyticsService} from './analytics/analytics.service';
import {ILobbyGameInfoPreviewService} from './lobby-game-info-preview/lobby-game-info-preview.service.interface';
import {GamesService} from './games/games.service';
import {IConfigurationService} from './configurations/configuration.service.interface';
import {ConfigurationsService} from './configurations/configurations.service';
import {Lazy} from '../../utils/lazy';
import {IUserService} from './user/user.service.interface';
import {UserService} from './user/user.service';
import {ISegmentationAggregatorService} from './segmentation-aggregator/segmentation-aggregator.service.interface';
import {SegmentationAggregatorService} from './segmentation-aggregator/segmentation-aggregator.service';
import {ILauncherService} from './launcher/launcher.service.interface';
import {IClientDeviceService} from './client-device/client-device.service.interface';
import {IDeviceService} from './device/device.service.interface';
import {DeviceService} from './device/device.service';
import {IWindowService} from './window/window.service.interface';
import {IAiEngineService} from './ai-engine/ai-engine.service.interface';
import {AiEngineService} from './ai-engine/ai-engine.service';
import {IHttpService} from './http/http.service.interface';
import {IDeepLinkService} from './deep-link/deep-link.service.interface';
import {ISdkService} from './sdk/sdk.service.interface';
import {SdkService} from './sdk/sdk.service';
import {IServiceFactoryExtended} from './service-factory-extended.interface';
import {IGamesFilterService} from './games-filter/games-filter.service.interface';
import {GamesFilterService} from './games-filter/games-filter.service';
import {IUserMenuService} from "./user-menu/user-menu.service.interface";
import {IArenasService} from './arenas/arenas.service.interface';
import {ArenasService} from './arenas/arenas.service';
import {IDomService} from './dom/dom.service.interface';
import {ISiteMapService} from './sitemap/sitemap.service.interface';
import {IMarketingService} from './marketing/marketing.service.interface';
import {ILanguageData, ILanguageService} from './language/language.service.interface';
import {LanguageService} from './language/language.service';
import {ISideMenuService} from './side-menu/side-menu.service.interface';
import {IGameSearchService} from './game-search/game-search.service.interface';
import {IExternalLinksService} from './external-links/external-links.service.interface';
import {ICmsApiService} from './cms/cms-api/cms-api.service.interface';
import {ICmsBannersService} from './cms/cms-banners/cms-banners.service.interface';
import {IStorageService} from './storage/storage.service.interface';
import {ICmsPagesService} from './cms/cms-pages/cms-pages.service.interface';
import {ICmsSegmentationService} from './cms/cms-segmentation/cms-segmentation.service.interface';
import {IDeepLinkActionsFactoryService} from './deep-link/deep-link-action-factory/deep-link-actions-factory.service.inteface';
import {IDeepLinkParserService} from './deep-link/legacy/deep-link-parsers/deep-link-parser.service.interface';
import {IStickyHandlerFactoryService} from "./sticky-handler-factory/sticky-handler-factory.service.interface";
import {StickyHandlerFactoryService} from "./sticky-handler-factory/sticky-handler-factory.service";
import {IGamePreviewFeaturesSelectorService} from './game-preview-features-selector/game-preview-features-selector.service.interface';
import {GameRouteHandlerService} from './game-route-handler/game-route-handler.service';
import {LauncherService} from './launcher/launcher.service';
import {SpinnerService} from './spinner/spinner.service';
import {CrossBrandsService} from './cross-brands/cross-brands.service';
import {ILocationService} from './location/location.service.interface';
import {LocationService} from './location/location.service';
import {IRoutingConfigurationService} from './routing-configuration/routing-configuration.service.interface';
import {RoutingConfigurationService} from './routing-configuration/routing-configuration.service';
import {IRoutingService} from './routing/routing.service.interface';
import {RoutingService} from './routing/routing.service';
import {IOverlayService} from './overlay/overlay.service.interface';
import {OverlayService} from './overlay/overlay.service';
import {ApplicationStartupConfigurations} from '../app-bootstrap/config-interfaces/application-startup.configurations';
import {SplashService} from './splash/splash.service';
import {ISplashService} from './splash/splash-service.interface';
import {ITimeService} from './time/time.service.interface';
import {TimeService} from './time/time.service';
import {IAiNewGamesEngineService} from "./ai-new-games-engine/ai-new-games.service.interface";
import {AiNewGamesEngineService} from "./ai-new-games-engine/ai-new-games.service";
import {IThemeService} from './theme/theme.service.interface';
import {ThemeService} from './theme/theme.service';
import {MiniOrbitService} from './mini-orbit/mini-orbit.service';
import {IMiniOrbitService} from "./mini-orbit/mini-orbit.service.interface";
import {DialogButtonClickHandleResultEnum, IDialogService} from './dialog/dialog.service.interface';
import {DialogService} from './dialog/dialog.service';
import {IHeaderService} from './header/header.service.interface';
import {IProgressiveWebAppService} from './progressive-web-app/progressive-web-app.service.interface';
import {IPWAManifestService} from './manifest/pwa-manifest.service.interface';
import {PWAManifestService} from './manifest/pwa-manifest.service';
import {IMiniOrbitCommunicationAdapterFactoryService} from './mini-orbit/adapter-factory/mini-orbit-communication-adapter-factory.service.interface';
import {MiniOrbitCommunicationAdapterFactoryService} from './mini-orbit/adapter-factory/mini-orbit-communication-adapter-factory.service';
import {ILiveTableFeedsService} from './live-table-feeds-service/live-table-feeds.service.interface';
import {LiveTableFeedsService} from './live-table-feeds-service/live-table-feeds.service';
import {IDrawerService} from './drawer/drawer.service.interface';
import {IDailyDealService} from './daily-deal/daily-deal.service.interface';
import {IAbTestingFeatureDataProviderService} from './ab-testing/ab-testing-feature-data-provider.service.interface';
import {AbTestingFeatureDataProviderService} from './ab-testing/ab-testing-feature-data-provider.service';
import {IControlCenterService} from "./control-center/control-center.service.interface";
import {ControlCenterService} from "./control-center/control-center.service";
import {IWalletService} from './wallet/wallet.service.interface';
import {WalletService} from './wallet/wallet.service';
import {SdkHooksProvider} from '../app-bootstrap/sdk-initializer/sdk-hooks-provider';
import {IGamePopupService} from "./game-popup/game-popup.service.interface";
import {IHomepageService} from "./homepage/homepage.service.interface";
import {HomepageService} from "./homepage/homepage.service";
import {IAnalyticsDataLayerService} from "./analytics/analytics-data-layer.service.interface";
import {IMediaQueryService} from './media-query/media-queries.interface';
import {MediaQueryService} from './media-query/media-query.service';

import {IToolsService} from "./tools/tools.service.interface";
import {ToolsService} from "./tools/tools.service";
import {IVerticalGamesListService} from "./vertical-games-list/vertical-games-list.service.interface";
import {IUserGameOrientationService} from "./user-game-orientation/user-game-orientation.service.interface";
import {UserGameOrientationService} from "./user-game-orientation/user-game-orientation.service";
import {ApiService} from './api/api.service';

import {OrbitComponentToSdkAdapterService} from './orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service';
import {IOrbitComponentsInsideSdkProvider} from './orbit-component-to-sdk-adapter/orbit-components-inside-sdk-provider.interface';
import {IOmgService} from './omg-proxy/omg.service.interface';
import {IMessageBrokerService} from './casinofied/message-broker/message-broker.service.interface';
import {MessageBrokerService} from './casinofied/message-broker/message-broker.service';
import {ICasinofiedAppLauncherService} from './casinofied/app-launcher/casinofied-app-launcher.service.interface';
import {CasinofiedActionHandlerService} from './casinofied/action-handler/casinofied-action-handler.service';
import {IFloatingBubblesService} from './floating-bubbles/floating-bubbles.service.interface';
import {FloatingBubblesService} from './floating-bubbles/floating-bubbles.service';
import {IRestrictionRulerService} from "./restriction-ruler/restriction-ruler.service.interface";
import {RestrictionRulerService} from "./restriction-ruler/restriction-ruler.service";
import {IRedTigerService} from './red-tiger/red-tiger.service.interface';
import {CasinofiedAnalyticsService} from './casinofied/analytics-publisher/casinofied-analytics.service';
import {IAbTestingAiSortGamesListsService} from "./ab-testing-ai-sort/ab-testing-ai-sort-games-lists.service.interface";
import {AbTestingAiSortGamesListsService} from "./ab-testing-ai-sort/ab-testing-ai-sort-games-lists.service";
import {ICashierService} from "../../common/interfaces/cashier.service.interface";
import {CashierService} from "./cashier/cashier.service";
import {IRegulationService} from './regulation/regulation.service.interface';
import {RegulationService} from './regulation/regulation.service';
import {LimitsToasterService} from './limits-toaster/limits-toaster.service';
import {PlayerBurnoutService} from './burnout/player-burnout.service';
import {IPlayerBurnoutService} from './burnout/player-burnout.service.interface';
import {IPlayerOfferingsService} from './player-offerings/player-offerings.service.interface';
import {PlayerOfferingsService} from './player-offerings/player-offerings.service';
import {IGsapService} from './gsap/gsap.service.interface';
import {PixiAppService} from './pixi-app/pixi-app.service';
import {IPixiAppService} from './pixi-app/pixi-app.service.interface';
import {IGameAnimatedIconsManagerService} from './game-animated-icons-manager/game-animated-icons-manager.service.interface';
import {GameAnimatedIconsManagerService} from './game-animated-icons-manager/game-animated-icons-manager.service';
import {IWebGLContextManagerService} from './webgl-context-manager/webgl-context-manager.service.interface';
import {WebGLContextManagerService} from './webgl-context-manager/webgl-context-manager.service';
import {IExitPopupService} from "./exit-popup/exit-popup.service.interface";
import {RegularTooltipsService} from "./tooltip/regular-tooltip/regular-tooltips.service";
import {IRegularTooltipsService} from "./tooltip/regular-tooltip/regular-tooltips.service.interface";
import {GamingHistoryService} from "./gaming-history/gaming-history.service";
import {IGamingHistoryService} from "./gaming-history/gaming-history.service.interfce";
import {ICompaniesService} from "./companies/companies.service.interface";
import {IBecauseYouPlayedService} from './because-you-played/because-you-played.service.interface';
import {BecauseYouPlayedService} from './because-you-played/because-you-played.service';
import {IGameRunnerService} from "./game-runner/game-runner.service.interface";
import {IOrbitHybridService} from "./hybrid/hybrid.service.interface";
import {HybridService} from "./hybrid/hybrid.service";
import {StaticVideoPlayingService} from "./video-live-stream/static-video-playing.service";
import {SessionStorageService} from "./storage/session-storage.service";
import {ICookiesService} from "./storage/cookies.service.interface";
import {CookiesService} from "./storage/cookies.service";
import {IFreePlayService} from "./free-play/free-play.service.interface";
import {FreePlayService} from "./free-play/free-play.service";
import {IRestrictionsService} from "./restrictions/restrictions.service.interface";
import {RestrictionsService} from "./restrictions/restrictions.service";
import {IFreeToPlayService} from "./free-to-play/free-to-play.service.interface";
import {FreeToPlayService} from "./free-to-play/free-to-play.service";
import {IThemeDefinition} from "./theme/theme-definition.interface";
import {IGnwpService} from "./gnwp/gnwp.service.interface";
import {IScriptLoaderService} from "./scrip-loader/script-loader.service.interface";
import {ScriptLoaderService} from "./scrip-loader/script-loader.service";
import {IAdminBannerService} from "./admin-banner/admin-banner-service.interface";
import {ISessionTimerService} from "./session-timer/session-timer.service.interface";
import {SessionTimerService} from "./session-timer/session-timer.service";
import {ICasinofiedAnalyticsService} from "../../common/interfaces/casinofied-analytics-proxy.interface";
import {IGeoLocationService} from "./geo-location/geo-location.service.interface";
import {ICrmService} from './crm/crm.service.interface';
import {CrmService} from './crm/crm.service';
import {ISpecificDialogsService} from './specific-dialogs/specific-dialogs.service.interface';
import {SpecificDialogsService} from './specific-dialogs/specific-dialogs.service';
import {ITippingHistoryService} from './tipping-history/tipping-history.service.interface';
import {TippingHistoryService} from './tipping-history/tipping-history.service';
import {LoyaltyService} from './loyalty-indicator/loyalty-indicator.service';
import {ILoyaltyService} from './loyalty-indicator/loyalty-indicator.service.interface';
import {StateOfResidenceIdentifierService} from "./state-of-residence-identifier/state-of-residence-identifier.service";
import {IStateOfResidenceIdentifier} from "./state-of-residence-identifier/state-of-residence-identifier.interface";
import {ILoginPopupService} from "./login-popup/login-popup.service.interface";
import {IOnboardingTourService} from './onboarding-tour/onboarding-tour.service.interface';
import {OnboardingTourService} from './onboarding-tour/onboarding-tour.service';
import {INyxService} from "./nyx/nyx.service.interface";
import {NyxService} from "./nyx/nyx.service";
import {IOnBoardingTooltipsService} from "./tooltip/on-boarding-tooltip/on-boarding-tooltips.service.interface";
import {OnBoardingTooltipsService} from "./tooltip/on-boarding-tooltip/on-boarding-tooltips.service";
import {PlayerMigrationService} from "./player-migration/player-migration.service";
import IPlayerMigration from "../../common/interfaces/player-migration.interface";
import {IToasterService} from "./toaster/toaster.service.interface";
import {ToasterService} from "./toaster/toaster.service";
import {IFeaturesToggleManagementService} from "./features-toggle-management/features-toggle-management.service.interface";
import {FeaturesToggleManagementService} from "./features-toggle-management/features-toggle-management.service";
import {ICrossBrandsService} from "./cross-brands/cross-brands.service.interface";
import {ILinksNavigationService} from "./links-navigation/links-navigation.service.interface";
import {LinksNavigationService} from "./links-navigation/links-navigation.service";
import {IMenuItemActionFactoryService} from "./menu-item-action-factory/menu-item-action-factory.service.interface";
import {
    IBottomNavigationBarService
} from "./bottom-navigation-bar/bottom-navigation-bar.service.interface";
import {IGameRouteHandlerService} from "./game-route-handler/game-route-handler.service.interface";
import {FirebaseToasterService} from "./toaster/firebase-toaster.service";
import {ISpinnerService} from "../../common/interfaces/spinner.service.interface";
import {GamesThemeService} from './game-theme/games-theme.service';
import {IGamesThemeService} from './game-theme/games-theme.service.interface';
import {GamesVendorService} from './game-vendor/games-vendor.service';
import {IGamesVendorService} from './game-vendor/games-vendor.service.interface';
import {FirebaseService} from "./firebase/firebase.service";
import {IFirebaseService} from "./firebase/firebase.service.interface";
import {VideoSlidesService} from './video-slides/video-slides.service';
import {IVideoSlidesService} from './video-slides/video-slides.service.interface';
import {IWebVitalsService} from "./web-vitals/web-vitals.service.interface";
import {IGamblingSessionService} from "./gambling-session/gambling-session.service.interface";
import {GamblingSessionService} from "./gambling-session/gambling-session.service";
import {LazyAsync} from "../../utils/lazy-async";
import {ILazy} from "../../utils/lazy.interface";
import {IServiceProvider} from "./service-factory.interface";
import {ServicesGroupLoader} from "../services-groups/services-group-loader";
import {IThemeBoxes} from "./theme/theme-boxes.interface";
import {INotificationsService} from "./notifications/notifications.service.interface";
import {NotificationsService} from "./notifications/notifications.service";
import {VideoOnDemandPlayingService} from './video-live-stream/video-on-demand-playing.service';
import {VersionNumber} from "../../utils/version-number";
import {Nullable, NullableString} from "../../common/types/nullable-types";
import {HeaderService} from './header/header.service';
import {MenuItemActionFactoryService} from './menu-item-action-factory/menu-item-action-factory.service';
import {IGamesOpenSessionService} from "./games-open-sessions/games-open-session.service.interface";
import {IVideoService} from "./video/video.service.interface";
import {VideoService} from "./video/video.service";
import {IdleRecommendationsService} from './idle-recommendations/idle-recommendations.service';
import {IJackpotsService} from "./jackpots/jackpots.service.interface";
import {IApplicationService} from "./application/application.service.interface";
import {ApplicationService} from "./application/application.service";
import {ILocalStorageService} from "./storage/local-storage-service.interface";
import {ICryptoService} from "./crypto/crypto.service.interface";
import {CryptoService} from "./crypto/crypto.service";
import {BonusAbuseMoneyParkingService} from "./bonus-abuse-money-parking/bonus-abuse-money-parking.service";
import {IAiRecommendationsReaderService} from "./ai-recommendations-reader/ai-recommendations-reader.service.interface";
import {AiRecommendationsReaderService} from "./ai-recommendations-reader/ai-recommendations-reader.service";
import {ClientSettingsService} from './client-settings/client-settings.service';
import {IClientSettingsService} from './client-settings/client-settings.service.interface';
import {IJackpotBetsService} from './jackpot-bet/jackpot-bets.service.interface';
import {JackpotBetsService} from './jackpot-bet/jackpot-bets.service';
import {Magic8BallService} from './magic-8-ball/magic-8-ball.service';
import {IMagic8BallService} from './magic-8-ball/magic-8-ball.service.interface';
import {ITabsNavigationService} from './tabs-navigation/tabs-navigation.interface';
import {TabsNavigationService} from './tabs-navigation/tabs-navigation.service';


export class ServiceFactory implements IServiceFactoryExtended, IServiceProvider {
    readonly splash: ISplashService;
    readonly logger: ILoggerService;
    readonly localStorage: ILocalStorageService;
    readonly window: IWindowService;
    readonly dom: IDomService;
    readonly http: IHttpService;
    readonly sdkHooksProvider: SdkHooksProvider;
    readonly _groupsLoader: ServicesGroupLoader;

    constructor(sdkHooksProvider: SdkHooksProvider,
                logger: ILoggerService,
                localStorage: ILocalStorageService,
                windowService: IWindowService,
                domService: IDomService,
                httpService: IHttpService,
                themeDefinition: IThemeDefinition,
                themeDefaultBoxes: IThemeBoxes,
                private _appStartupConfigs: ApplicationStartupConfigurations,
                private _languageData: ILanguageData) {

        this._groupsLoader = new ServicesGroupLoader();
        sdkHooksProvider.services = this;

        this.logger = logger;
        this.splash = new SplashService(() => {
            this.hybrid.displayWebView(200);
        });

        this.localStorage = localStorage;
        this.window = windowService;
        this.dom = domService;
        this.http = httpService;
        this._themeDefinition = themeDefinition;
        this._themeDefaultBoxes = themeDefaultBoxes;

        this._sdk.forceInit();
        this._application.forceInit();
        this._configuration.forceInit();
        this._featuresToggleManagement.forceInit();
        this._userService.forceInit();
        this._abTestingFeatureDataProvider.forceInit();
        this._spinner.forceInit();
        this._location.forceInit();
        this._routing.forceInit();
        this._segmentation.forceInit();

        this._deepLink.forceInit();

        this._cmsPages.forceInit();
        this._marketing.forceInit();

        this._siteMap.forceInit();
        this._games.forceInit();

        this._gamesFilter.forceInit();

        this._gameRouteHandler.forceInit();

        this._aiEngine.forceInit();
        this._aiNewEngine.forceInit();

        //this._lobbyGameInfoPreview.forceInit();

        this._crossBrands.forceInit();
        this._userMenu.forceInit();
        //this._externalLinks.forceInit();
        this._theme.forceInit();
        this._miniOrbit.forceInit();
        this._pwaManifest.forceInit();
        this._progressiveWebApp.forceInit();
        //this._drawerService.forceInit();
        this._controlCenter.forceInit();
        this._gamePopup.forceInit();
        this._homepageService.forceInit();
        this._userGameOrientationService.forceInit();

        this._appLauncher.forceInit();
        this._actionHandler.forceInit();
        this._restrictionRuler.forceInit();
        this._casinofiedAnalytics.forceInit();
        this._limitsToaster.forceInit();
        this._exitPopup.forceInit();

        this._sideMenu.forceInit();
        this._tabsNavigation.forceInit();
        this._regularToolTip.forceInit();
        this._gameSearch.forceInit();
        this._gameRunner.forceInit();
        this._freePlay.forceInit();
        this._adminBanner.forceInit();
        this._sessionTimer.forceInit();
        this._firebase.forceInit();
        this._crm.forceInit();

        this._stateOfResidenceIdentifier.forceInit();
        this._wallet.forceInit();
        this._loginPopup.forceInit();
        this._omg.forceInit();
        this._dailyDeal.forceInit();
        this._onboardingTour.forceInit();
        this._onBoardingTooltip.forceInit();

        this._playerMigration.forceInit();
        this._toaster.forceInit();
        this._firebaseToaster.forceInit();
        this._cookies.forceInit();
        if(this.configuration.servicesConfigs.GeoLocation.enable) {
            this._geoLocation.forceInit();
        }

        this._jackpots.forceInit();

        this._gamblingSession.forceInit();

        this.sdk.fireOrbitInitComplete();

        this._idleRecommendations.forceInit();
        this._restrictions.forceInit();

        this._jackpotBet.forceInit();
        this._bonusAbuseMoneyParking.forceInit();

        this._tabsNavigation.forceInit();

        setTimeout(() => this._forceUpgradeHybridOnIos());
    }

    //TODO - this should be removed when we are sure that there are no more users with older version
    private _forceUpgradeHybridOnIos(): void {

        if(!(this.device.os.isIOS && this.device.hybrid.isHybrid)) {
            return;
        }

        if(this.miniOrbit.isEnabled) {
            return;
        }

        const currentHybridVersion = this.hybrid.getAppVersion();
        if(!currentHybridVersion) {
            return;
        }

        let expectedHybridVersion: Nullable<VersionNumber> = null;
        let appStoreUrl: NullableString = null;

        if(this.sdk.getBrandID() === 81) { //888 sweden
            expectedHybridVersion = new VersionNumber(2, 8, 3971451701);
            appStoreUrl = 'https://apps.apple.com/se/app/888-casino-spela-online/id1436816261';
        } else if(this.sdk.getBrandID() === 92) { //MrGreen sweden
            expectedHybridVersion = new VersionNumber(2, 8, 3971451702);
            appStoreUrl = 'https://apps.apple.com/se/app/mr-green-casino-blackjack/id1664477817';
        }

        if(!expectedHybridVersion) {
            return;
        }

        if(currentHybridVersion.isSmallerThan(expectedHybridVersion)) {
            this.analytics.sendTechnicalEvent('UpgradeIosVersion', 'popupShow', currentHybridVersion.toString())
            this.dialog.showSimpleTextModal({
                title: 'Vi har uppgraderat vår app',
                text: 'Klicka nedan för att hämta den senaste versionen och logga in',
                hideCloseButton: true,
                disableFullscreenMobile: false,
                buttons: [
                    {
                        text: 'Uppdatera app',
                        buttonPreset: this.sdk.getBrandID() === 92 ? 'special' : 'primary',
                        onClick: async () => {
                            this.analytics.sendTechnicalEvent('UpgradeIosVersion', 'buttonClick', currentHybridVersion.toString())
                            this.hybrid.openExternalLink(appStoreUrl);
                            return DialogButtonClickHandleResultEnum.KeepDialogOpen;
                        }
                    }
                ]
            })
        }

    }

    getServiceByName(name: string): unknown | Promise<unknown> {
        let serviceInstance: unknown = this[`_${name}`];
        if(!serviceInstance) {
            serviceInstance = this[name];
        }

        if(serviceInstance) {
            if((serviceInstance as ILazy).isLazy) {
                return (serviceInstance as ILazy).tryGetResolvedValue();
            } else {
                return serviceInstance;
            }
        }

        throw new Error(`tryGetResolvedAsyncService called with an invalid service name: ${name}`);

    }

    private _externalLinks = new LazyAsync<IExternalLinksService>(async () => {
        const {ExternalLinksService} = await import(/* webpackChunkName: "service-external-links" */ './external-links/external-links.service');
        return new ExternalLinksService(this);
    });
    public get externalLinks(): Promise<IExternalLinksService> {
        return this._externalLinks.value;
    }

    private _userMenu = new LazyAsync<IUserMenuService>(async () => {
        const {UserMenuService} = await import(/*webpackChunkName: "service-user-menu"*/ "./user-menu/user-menu.service");
        return new UserMenuService(this, this.menuItemActionFactory);
    });
    public get userMenu(): Promise<IUserMenuService> {
        return this._userMenu.value;
    }

    private _crossBrands = new Lazy<ICrossBrandsService>(() => new CrossBrandsService(this));
    public get crossBrands(): ICrossBrandsService {
        return this._crossBrands.value;
    }

    private _verticalGamesList = new LazyAsync<IVerticalGamesListService>(async () => {
        const {VerticalGamesListService} = await import(/*webpackChunkName: "service-vertical-games-list" */ './vertical-games-list/vertical-games-list.service');
        return new VerticalGamesListService(this);
    });
    public get verticalGamesList(): Promise<IVerticalGamesListService> {
        return this._verticalGamesList.value;
    }

    private _lobbyGameInfoPreview = new LazyAsync<ILobbyGameInfoPreviewService>(async () => {
        const {LobbyGameInfoPreviewService} = await this._groupsLoader.loadGroup5();
        return new LobbyGameInfoPreviewService(this);
    });
    public get lobbyGameInfoPreview(): Promise<ILobbyGameInfoPreviewService> {
        return this._lobbyGameInfoPreview.value;
    }

    private _gamePreviewFeaturesSelector = new LazyAsync<IGamePreviewFeaturesSelectorService>(async () => {
        const {GamePreviewFeaturesSelectorService} = await this._groupsLoader.loadGroup5();
        return new GamePreviewFeaturesSelectorService(this);
    });
    get gamePreviewFeaturesSelector(): Promise<IGamePreviewFeaturesSelectorService> {
        return this._gamePreviewFeaturesSelector.value;
    }

    private _aiEngine = new Lazy<IAiEngineService>(() => new AiEngineService(this));
    public get aiEngine(): IAiEngineService {
        return this._aiEngine.value;
    }

    private _aiNewEngine = new Lazy<IAiNewGamesEngineService>(() => new AiNewGamesEngineService(this));
    public get aiNewEngine(): IAiNewGamesEngineService {
        return this._aiNewEngine.value;
    }

    private _deepLink = new LazyAsync<IDeepLinkService>(async () => {
        const {DeepLinkService} = await this._groupsLoader.loadGroup3();
        return new DeepLinkService(this);
    });
    public get deepLink(): Promise<IDeepLinkService> {
        return this._deepLink.value;
    }

    private _gameRouteHandler = new Lazy<IGameRouteHandlerService>(() => new GameRouteHandlerService(this));
    public get gameRouteHandler(): IGameRouteHandlerService {
        return this._gameRouteHandler.value;
    }

    private _gamesFilter = new Lazy<IGamesFilterService>(() => new GamesFilterService(this));
    public get gamesFilter(): IGamesFilterService {
        return this._gamesFilter.value;
    }

    private _becauseYouPlayed = new Lazy<IBecauseYouPlayedService>(() => new BecauseYouPlayedService(this));
    public get becauseYouPlayed(): IBecauseYouPlayedService {
        return this._becauseYouPlayed.value;
    }

    private _games = new Lazy<IGamesService>(() => new GamesService(this));
    public get games(): IGamesService {
        return this._games.value;
    }

    private _siteMap = new LazyAsync<ISiteMapService>(async () => {
        const {SiteMapService} = await this._groupsLoader.loadGroup4();
        return new SiteMapService(this);
    });
    public get siteMap(): Promise<ISiteMapService> {
        return this._siteMap.value;
    }

    private _marketing = new LazyAsync<IMarketingService>(async () => {
        const {MarketingService} = await this._groupsLoader.loadGroup4();
        return new MarketingService(this);
    });
    public get marketing(): Promise<IMarketingService> {
        return this._marketing.value;
    }

    private _cmsPages = new LazyAsync<ICmsPagesService>(async () => {
        const {CmsPagesService} =  await this._groupsLoader.loadGroup1();
        return new CmsPagesService(this);
    });
    public get cmsPages(): Promise<ICmsPagesService> {
        return this._cmsPages.value;
    }

    private _configuration = new Lazy<IConfigurationService>(() => new ConfigurationsService(this, this._appStartupConfigs));
    public get configuration(): IConfigurationService {
        return this._configuration.value;
    }

    private _spinner = new Lazy<ISpinnerService>(() => new SpinnerService(this));
    public get spinner(): ISpinnerService {
        return this._spinner.value;
    }

    private _webVitals = new LazyAsync<IWebVitalsService>(async () => {
        const {WebVitalsService} = await import(/* webpackChunkName: "service-web-vitals" */ './web-vitals/web-vitals.service');
        return new WebVitalsService(this);
    });
    public get webVitals(): Promise<IWebVitalsService> {
        return this._webVitals.value;
    }

    private _location = new Lazy<ILocationService>(() => new LocationService(window, this.localStorage, (action: string, label?: string, value?: any) => this.analytics.sendTechnicalEvent(action, label, value)));
    public get location(): ILocationService {
        return this._location.value;
    }

    private _routing = new Lazy<IRoutingService>(() => new RoutingService(this));
    public get routing(): IRoutingService {
        return this._routing.value;
    }

    private _regulation = new Lazy<IRegulationService>(() => new RegulationService(this));
    public get regulation(): IRegulationService {
        return this._regulation.value;
    }

    private _segmentation = new Lazy<ISegmentationAggregatorService>(() => new SegmentationAggregatorService(this));
    public get segmentation(): ISegmentationAggregatorService {
        return this._segmentation.value;
    }

    private _liveTableFeeds = new Lazy<ILiveTableFeedsService>(() => new LiveTableFeedsService(this));
    public get liveTableFeeds(): ILiveTableFeedsService {
        return this._liveTableFeeds.value;
    }

    private _translation = new Lazy<ITranslationService>(() => new TranslationService(this));
    public get translation(): ITranslationService {
        return this._translation.value;
    }

    private _currencyService = new Lazy<ICurrencyService>(() => new CurrencyService(this));

    public get currency(): ICurrencyService {
        return this._currencyService.value;
    }

    private _analyticsService = new Lazy<IAnalyticsService>(() => new AnalyticsService(this));

    public get analytics(): IAnalyticsService {
        return this._analyticsService.value;
    }

    private _analyticsDataLayerService = new LazyAsync<IAnalyticsDataLayerService>(async () => {
        const {AnalyticsDataLayerService} = await import(/*webpackChunkName: "service-analytics-data-layer" */ './analytics/analytics-data-layer.service');
        return new AnalyticsDataLayerService(this);
    });

    public get analyticsDataLayer(): Promise<IAnalyticsDataLayerService> {
        return this._analyticsDataLayerService.value;
    }

    private _userService = new Lazy<IUserService>(() => new UserService(this));

    get user(): IUserService {
        return this._userService.value;
    }


    private _homepageService = new Lazy<IHomepageService>(() => new HomepageService(this, this.menuItemActionFactory));
    get homepage(): IHomepageService {
        return this._homepageService.value;
    }

    private _userGameOrientationService = new Lazy<IUserGameOrientationService>(() => new UserGameOrientationService(this));

    get userGameOrientation(): IUserGameOrientationService {
        return this._userGameOrientationService.value;
    }

    private _cmsApi = new LazyAsync<ICmsApiService>(async () => {
        const {CmsApiService} = await this._groupsLoader.loadGroup1();
        return new CmsApiService(this);
    });
    get cmsApi(): Promise<ICmsApiService> {
        return this._cmsApi.value;
    }

    private _cmsBanners = new LazyAsync<ICmsBannersService>(async () => {
        const {CmsBannersService} = await this._groupsLoader.loadGroup1();
        return new CmsBannersService(this);
    });
    get cmsBanners(): Promise<ICmsBannersService> {
        return this._cmsBanners.value;
    }

    private _launcher = new Lazy<ILauncherService>(() => new LauncherService(this));
    get launcher(): ILauncherService {
        return this._launcher.value;
    }

    private _clientDevice = new LazyAsync<IClientDeviceService>(async () => {
        const {ClientDeviceService} = await import(/*webpackChunkName: "service-client-device" */ './client-device/client-device.service');
        return new ClientDeviceService(this);
    });
    get clientDevice(): Promise<IClientDeviceService> {
        return this._clientDevice.value;
    }

    private _device = new Lazy<IDeviceService>(() => new DeviceService(this));
    get device(): IDeviceService {
        return this._device.value;
    }

    private _deepLinkParser = new LazyAsync<IDeepLinkParserService>(async () => {
        const {DeepLinkParserService} = await this._groupsLoader.loadGroup3();
        return new DeepLinkParserService(this);
    });
    get deepLinkParser(): Promise<IDeepLinkParserService> {
        return this._deepLinkParser.value;
    }

    private _deepLinkActionsFactory = new LazyAsync<IDeepLinkActionsFactoryService>(async () => {
        const {DeepLinkActionsFactoryService} = await this._groupsLoader.loadGroup3();
        return new DeepLinkActionsFactoryService(this);
    });
    get deepLinkActionsFactory(): Promise<IDeepLinkActionsFactoryService> {
        return this._deepLinkActionsFactory.value;
    }

    private _sdk: Lazy<ISdkService> = new Lazy<ISdkService>(() => new SdkService(this));
    get sdk(): ISdkService {
        return this._sdk.value;
    }

    private _arenas = new Lazy<IArenasService>(() => new ArenasService(this));
    get arenas(): IArenasService {
        return this._arenas.value;
    }

    private _language = new Lazy<ILanguageService>(() => new LanguageService(this._languageData, this));
    get language(): ILanguageService {
        return this._language.value;
    }

    private _sideMenu = new LazyAsync<ISideMenuService>(async () => {
        const {SideMenuService} = await import(/* webpackChunkName: "service-side-menu" */ './side-menu/side-menu.service');

        return new SideMenuService(this, this.menuItemActionFactory);
    });
    get sideMenu(): Promise<ISideMenuService> {
        return this._sideMenu.value;
    }

    private _gameSearch = new LazyAsync<IGameSearchService>(async () => {
        const {GameSearchService} = await import(/* webpackChunkName: "service-game-search" */ './game-search/game-search.service')
        return new GameSearchService(this, this.menuItemActionFactory);
    });
    get gameSearch(): Promise<IGameSearchService> {
        return this._gameSearch.value;
    }

    private _gamePopup = new LazyAsync<IGamePopupService>(async () => {
        const {GamePopupService} = await import(/* webpackChunkName: "service-game-popup"*/ './game-popup/game-popup.service');
        return new GamePopupService(this);
    });
    get gamePopup(): Promise<IGamePopupService> {
        return this._gamePopup.value;
    }


    private _cmsSegmentation = new LazyAsync<ICmsSegmentationService>(async () => {
        const {CmsSegmentationService} = await this._groupsLoader.loadGroup1();
        return new CmsSegmentationService(this);
    });
    get cmsSegmentation(): Promise<ICmsSegmentationService> {
        return this._cmsSegmentation.value;
    }

    private _stickyHandlerFactory = new Lazy<IStickyHandlerFactoryService>(() => new StickyHandlerFactoryService(this));
    get stickyHandlerFactory(): IStickyHandlerFactoryService {
        return this._stickyHandlerFactory.value;
    }

    private _exitPopup = new LazyAsync<IExitPopupService>(async () => {
        const {ExitPopupService} = await this._groupsLoader.loadGroup2();
        return new ExitPopupService(this);
    });
    get exitPopup(): Promise<IExitPopupService> {
        return this._exitPopup.value;
    }

    private _routingConfiguration = new Lazy<IRoutingConfigurationService>(() => new RoutingConfigurationService(this));
    get routingConfiguration(): IRoutingConfigurationService {
        return this._routingConfiguration.value;
    }

    private _overlay = new Lazy<IOverlayService>(() => new OverlayService(this));
    get overlay(): IOverlayService {
        return this._overlay.value;
    }

    private _time = new Lazy<ITimeService>(() => new TimeService(this));
    get time(): ITimeService {
        return this._time.value;
    }

    private _abTestingFeatureDataProvider = new Lazy<IAbTestingFeatureDataProviderService>(() => new AbTestingFeatureDataProviderService(this));
    get abTestingFeatureDataProvider(): IAbTestingFeatureDataProviderService {
        return this._abTestingFeatureDataProvider.value;
    }

    private _abTestingAiSort = new Lazy<IAbTestingAiSortGamesListsService>(() => new AbTestingAiSortGamesListsService(this));

    get abTestingAiSortGamesLists(): IAbTestingAiSortGamesListsService {
        return this._abTestingAiSort.value;
    }


    private readonly _themeDefinition: IThemeDefinition ;
    private readonly _themeDefaultBoxes: IThemeBoxes;
    private _theme = new Lazy<IThemeService>(() => new ThemeService(this, this._themeDefinition, this._themeDefaultBoxes));
    get theme(): IThemeService {
        return this._theme.value;
    }

    private _miniOrbit = new Lazy<IMiniOrbitService>(() => new MiniOrbitService(this));
    public get miniOrbit(): IMiniOrbitService {
        return this._miniOrbit.value;
    }

    private _notifications = new Lazy<INotificationsService>(() => new NotificationsService(this));
    public get notifications(): INotificationsService {
        return this._notifications.value;
    }

    private _dialog = new Lazy<IDialogService>(() => new DialogService(this));
    public get dialog(): IDialogService {
        return this._dialog.value;
    }

    private _header = new Lazy<IHeaderService>(() => new HeaderService(this, this.menuItemActionFactory));
    public get header(): IHeaderService {
        return this._header.value;
    }

    private _pwaManifest = new Lazy<IPWAManifestService>(() => new PWAManifestService(this));
    public get manifest(): IPWAManifestService {
        return this._pwaManifest.value;
    }

    private _progressiveWebApp = new LazyAsync<IProgressiveWebAppService>(async () => {
        const {ProgressiveWebAppService} = await import(/* webpackChunkName: "service-progressive-web-app" */ './progressive-web-app/progressive-web-app.service');
        return new ProgressiveWebAppService(this);
    });
    public get progressiveWebApp(): Promise<IProgressiveWebAppService> {
        return this._progressiveWebApp.value;
    }

    private _miniOrbitCommunicationAdapterFactory = new Lazy<IMiniOrbitCommunicationAdapterFactoryService>(() => new MiniOrbitCommunicationAdapterFactoryService(this));
    public get miniOrbitCommunicationAdapterFactory(): IMiniOrbitCommunicationAdapterFactoryService {
        return this._miniOrbitCommunicationAdapterFactory.value;
    }


    //import {DrawerService} from './drawer/drawer.service';

    private _drawer = new LazyAsync<IDrawerService>(async () => {
        const {DrawerService} = await import(/* webpackChunkName: "service-drawer" */ './drawer/drawer.service');
        return new DrawerService(this)
    });

    public get drawer(): Promise<IDrawerService> {
        return this._drawer.value;
    }

    private _dailyDeal = new LazyAsync<IDailyDealService>(async () => {
        const {DailyDealService} = await import(/* webpackChunkName: "service-daily-deal" */ './daily-deal/daily-deal.service')
        return new DailyDealService(this);
    });
    public get dailyDeal(): Promise<IDailyDealService> {
        return this._dailyDeal.value;
    }

    private _omg = new LazyAsync<IOmgService>(async () => {
        const {OmgService} = await import(/* webpackChunkName: "service-omg" */ './omg-proxy/omg.service');
        return new OmgService(this);
    });
    public get omg(): Promise<IOmgService> {
        return this._omg.value;
    }


    private _jackpots = new LazyAsync<IJackpotsService>(async () => {
        const {JackpotsService} = await import(/* webpackChunkName: "service-jackpots" */ './jackpots/jackpots.service');
        return new JackpotsService(this);
    });
    public get jackpots(): Promise<IJackpotsService> {
        return this._jackpots.value;
    }

    private _wallet = new Lazy<IWalletService>(() => new WalletService(this));
    public get wallet(): IWalletService {
        return this._wallet.value;
    }

    private _controlCenter = new Lazy<IControlCenterService>(() => new ControlCenterService(this));
    public get controlCenter(): IControlCenterService {
        return this._controlCenter.value;
    }

    private _tools = new Lazy<IToolsService>(() => new ToolsService(this));
    public get tools(): IToolsService {
        return this._tools.value;
    }

    private _mediaQuery = new Lazy<IMediaQueryService>(() => new MediaQueryService(this));
    public get mediaQuery(): IMediaQueryService {
        return this._mediaQuery.value;
    }

    private _api = new Lazy<ApiService>(() => new ApiService(this));
    public get api(): ApiService {
        return this._api.value;
    }

    private _orbitComponentToSdkAdapter = new Lazy<IOrbitComponentsInsideSdkProvider>(() => new OrbitComponentToSdkAdapterService(this));

    public get orbitComponentInsideSdkProvider(): IOrbitComponentsInsideSdkProvider {
        return this._orbitComponentToSdkAdapter.value;
    }

    private _messageBroker = new Lazy<IMessageBrokerService>(() => new MessageBrokerService(this));
    public get messageBroker(): IMessageBrokerService {
        return this._messageBroker.value;
    }

    private _appLauncher = new LazyAsync<ICasinofiedAppLauncherService>(async () => {
        const {CasinofiedAppLauncherService} = await import(/* webpackChunkName: "service-casinofied-app-launcher"*/ './casinofied/app-launcher/casinofied-app-launcher.service');
        return new CasinofiedAppLauncherService(this);

    });
    public get appLauncher(): Promise<ICasinofiedAppLauncherService> {
        return this._appLauncher.value;
    }

    // No need to expose this service as public member. It is not consumed by any other service or component
    private _actionHandler = new Lazy<CasinofiedActionHandlerService>(() => new CasinofiedActionHandlerService(this));

    private _floatingBubbles = new Lazy<IFloatingBubblesService>(() => new FloatingBubblesService(this));
    public get floatingBubbles(): IFloatingBubblesService {
        return this._floatingBubbles.value;
    }

    private _restrictionRuler = new Lazy<IRestrictionRulerService>(() => new RestrictionRulerService(this));
    public get restrictionRuler(): IRestrictionRulerService {
        return this._restrictionRuler.value;
    }

    private _redTiger = new LazyAsync<IRedTigerService>(async () => {
        const { RedTigerService } = await import(/*webpackChunkName: "service-red-tiger"*/ './red-tiger/red-tiger.service');
        return new RedTigerService(this);
    });
    public get redTiger(): Promise<IRedTigerService> {
        return this._redTiger.value;
    }

    private _casinofiedAnalytics = new Lazy<ICasinofiedAnalyticsService>(() => new CasinofiedAnalyticsService(this));
    public get casinofiedAnalytics(): ICasinofiedAnalyticsService {
        return this._casinofiedAnalytics.value;
    }

    private _liveStreamPlaying = new Lazy<IVideoPlayingService>(() => new LiveStreamPlayingService(this));
    public get liveStreamPlaying(): IVideoPlayingService {
        return this._liveStreamPlaying.value;
    }

    private _staticVideoPlaying = new Lazy<IVideoPlayingService>(() => new StaticVideoPlayingService(this));
    public get staticVideoPlaying(): IVideoPlayingService {
        return this._staticVideoPlaying.value;
    }

    private _videoOnDemandPlaying = new Lazy<IVideoPlayingService>(() => new VideoOnDemandPlayingService(this));
    public get videoOnDemandPlaying(): IVideoPlayingService {
        return this._videoOnDemandPlaying.value;
    }

    private _cashier: Lazy<ICashierService> = new Lazy<ICashierService>(() => new CashierService(this));
    get cashier(): ICashierService {
        return this._cashier.value;
    }

    private _playerOfferings: Lazy<IPlayerOfferingsService> = new Lazy<IPlayerOfferingsService>(() => new PlayerOfferingsService(this));
    get playerOfferings(): IPlayerOfferingsService {
        return this._playerOfferings.value;
    }

    private _qaEnvironmentPopUpBlockerService = new Lazy<IQAEnvironmentPopUpBlockerService>(() => new QAEnvironmentPopUpBlockerService(this));
    public get qaEnvironmentPopUpBlockerService(): IQAEnvironmentPopUpBlockerService {
        return this._qaEnvironmentPopUpBlockerService.value;
    }

    private _limitsToaster = new Lazy<LimitsToasterService>(() => new LimitsToasterService(this));
    public get limitsToaster(): LimitsToasterService {
        return this._limitsToaster.value;
    }

    private _burnoutService = new Lazy<IPlayerBurnoutService>(() => new PlayerBurnoutService(this));
    public get burnoutService(): IPlayerBurnoutService {
        return this._burnoutService.value;
    }

    private _gsapService = new LazyAsync<IGsapService>(async () => {
        const {GsapService} = await import(/* webpackChunkName: "service-gsap" */ './gsap/gsap.service');
        return new GsapService(this)
    });
    public get gsap(): Promise<IGsapService> {
        return this._gsapService.value;
    }

    private _pixiAppService = new Lazy<IPixiAppService>(() => new PixiAppService(this));
    public get pixiApp(): IPixiAppService {
        return this._pixiAppService.value;
    }

    private _gameAnimatedIconsManagerService = new Lazy<IGameAnimatedIconsManagerService>(() => new GameAnimatedIconsManagerService(this));
    public get gameAnimatedIconsManager(): IGameAnimatedIconsManagerService {
        return this._gameAnimatedIconsManagerService.value;
    }

    private _webGlContextManagerService = new Lazy<IWebGLContextManagerService>(() => new WebGLContextManagerService(this));
    public get webGlContextManager(): IWebGLContextManagerService {
        return this._webGlContextManagerService.value;
    }

    private _regularToolTip = new Lazy<IRegularTooltipsService>(() => new RegularTooltipsService(this));
    public get regularTooltips(): IRegularTooltipsService {
        return this._regularToolTip.value;
    }

    private _onBoardingTooltip = new Lazy<IOnBoardingTooltipsService>(() => new OnBoardingTooltipsService(this));
    public get onBoardingTooltips(): IOnBoardingTooltipsService {
        return this._onBoardingTooltip.value;
    }



    private _gamingHistory = new Lazy<IGamingHistoryService>(() => new GamingHistoryService(this));
    public get gamingHistory(): IGamingHistoryService {
        return this._gamingHistory.value;
    }

    private _tippingHistory = new Lazy<ITippingHistoryService>(() => new TippingHistoryService(this));
    public get tippingHistory(): ITippingHistoryService {
        return this._tippingHistory.value;
    }

    private _companies = new LazyAsync<ICompaniesService>(async () => {
        const {CompaniesService} = await import(/* webpackChunkName: "service-companies"*/ './companies/companies.service');
        return new CompaniesService(this)
    });
    public get companies(): Promise<ICompaniesService> {
        return this._companies.value;
    }

    private _freeToPlayService = new Lazy<IFreeToPlayService>(() => new FreeToPlayService(this));
    public get freeToPlay(): IFreeToPlayService {
        return this._freeToPlayService.value;
    }

    private _gameRunner = new LazyAsync<IGameRunnerService>(async () => {
        const {GameRunnerService} = await import(/* webpackChunkName: "service-game-runner" */ './game-runner/game-runner.service');
        return new GameRunnerService(this);
    });
    public get gameRunner(): Promise<IGameRunnerService> {
        return this._gameRunner.value;
    }

    private _hybrid = new Lazy<IOrbitHybridService>(() => new HybridService(this));
    public get hybrid(): IOrbitHybridService {
        return this._hybrid.value;
    }

    private _sessionStorage = new Lazy<IStorageService>(() => new SessionStorageService(this.logger));
    public get sessionStorage(): IStorageService {
        return this._sessionStorage.value;
    }

    private _cookies = new Lazy<ICookiesService>(() => new CookiesService());
    public get cookies(): ICookiesService {
        return this._cookies.value;
    }

    private _freePlay = new Lazy<IFreePlayService>(() => new FreePlayService(this));
    public get freePlay(): IFreePlayService {
        return this._freePlay.value;
    }

    private _restrictions = new Lazy<IRestrictionsService>(() => new RestrictionsService(this));
    public get restrictions(): IRestrictionsService {
        return this._restrictions.value;
    }

    private _gnwp = new LazyAsync<IGnwpService>(async () => {
        const {GnwpService} = await import(/*webpackChunkName: "service-gnwp" */ './gnwp/gnwp.service');
        return new GnwpService(this);
    });
    public get gnwp(): Promise<IGnwpService> {
        return this._gnwp.value;
    }

    private _scriptLoader = new Lazy<IScriptLoaderService>(() => new ScriptLoaderService(this));
    public get scriptLoader(): IScriptLoaderService {
        return this._scriptLoader.value;
    }

    private _adminBanner = new LazyAsync<IAdminBannerService>(async () => {
        const {AdminBannerService} = await import(/*webpackChunkName: "service-adm-banner" */ './admin-banner/admin-banner.service');
        return new AdminBannerService(this);
    });
    get adminBanner(): Promise<IAdminBannerService> {
        return this._adminBanner.value;
    }

    private _sessionTimer = new Lazy<ISessionTimerService>(() => new SessionTimerService(this));
    get sessionTimer(): ISessionTimerService {
        return this._sessionTimer.value;
    }

    private _geoLocation = new LazyAsync<IGeoLocationService>(async () => {
        const {GeoLocationService} = await import(/*webpackChunkName: "service-geolocation" */ './geo-location/geo-location.service');
        return new GeoLocationService(this)
    });
    get geoLocation(): Promise<IGeoLocationService> {
        return this._geoLocation.value;
    }

    private _crm = new Lazy<ICrmService>(() => new CrmService(this));
    get crm(): ICrmService {
        return this._crm.value;
    }

    private _specificDialogs = new Lazy<ISpecificDialogsService>(() => new SpecificDialogsService(this));
    get specificDialogs(): ISpecificDialogsService {
        return this._specificDialogs.value
    }

    private _stateOfResidenceIdentifier = new Lazy<IStateOfResidenceIdentifier>(() => new StateOfResidenceIdentifierService(this));
    get stateOfResidenceIdentifier(): IStateOfResidenceIdentifier {
        return this._stateOfResidenceIdentifier.value;
    }

    private _loyaltyIndicator = new Lazy<ILoyaltyService>(() => new LoyaltyService(this));
    get loyaltyIndicator(): ILoyaltyService {
        return this._loyaltyIndicator.value
    }

    private _loginPopup = new LazyAsync<ILoginPopupService>(async () => {
        const {LoginPopupService} = await this._groupsLoader.loadGroup2();
        return new LoginPopupService(this);
    });
    get loginPopup(): Promise<ILoginPopupService> {
        return this._loginPopup.value;
    }

    private _onboardingTour = new Lazy<IOnboardingTourService>(() => new OnboardingTourService(this));
    get onboardingTour(): IOnboardingTourService {
        return this._onboardingTour.value;
    }

    private _nyx = new Lazy<INyxService>(() => new NyxService(this));
    get nyx(): INyxService {
        return this._nyx.value;
    }

    private _playerMigration = new Lazy<IPlayerMigration>(() => new PlayerMigrationService(this));
    get playerMigration(): IPlayerMigration {
        return this._playerMigration.value;
    }

    private _toaster = new Lazy<IToasterService>(() => new ToasterService(this));
    get toaster(): IToasterService {
        return this._toaster.value;
    }

    private _idleRecommendations = new Lazy<IdleRecommendationsService>(() => new IdleRecommendationsService(this));

    private _featuresToggleManagement = new Lazy<IFeaturesToggleManagementService>(() => new FeaturesToggleManagementService(this));
    get featuresToggleManagement(): IFeaturesToggleManagementService {
        return this._featuresToggleManagement.value;
    }

    private _linksNavigation = new Lazy<ILinksNavigationService>(() => new LinksNavigationService(this));
    get linksNavigation(): ILinksNavigationService {
        return this._linksNavigation.value;
    }

    private _menuItemActionFactory = new Lazy<IMenuItemActionFactoryService>(() => new MenuItemActionFactoryService(this));
    get menuItemActionFactory(): IMenuItemActionFactoryService {
        return this._menuItemActionFactory.value;
    }

    private _bottomNavigationBar = new LazyAsync<IBottomNavigationBarService>(async () => {
        const {BottomNavigationBarService} = await import(/*webpackChunkName: "service-bottom-nav-bar"*/ "./bottom-navigation-bar/bottom-navigation-bar.service");
        return new BottomNavigationBarService(this, this.menuItemActionFactory);
    });
    get bottomNavigationBar(): Promise<IBottomNavigationBarService> {
        return this._bottomNavigationBar.value;
    }

    private _firebaseToaster = new Lazy<FirebaseToasterService>(() => new FirebaseToasterService(this));

    private _gamesTheme = new Lazy<IGamesThemeService>(() => new GamesThemeService(this))
    get gamesTheme(): IGamesThemeService {
        return this._gamesTheme.value;
    }

    private _gamesVendor = new Lazy<IGamesVendorService>(() => new GamesVendorService(this))
    get gamesVendor(): IGamesVendorService {
        return this._gamesVendor.value;
    }

    private _firebase = new Lazy<IFirebaseService>(() => new FirebaseService(this))
    get firebase(): IFirebaseService {
        return this._firebase.value;
    }
    private _videoSlides = new Lazy<IVideoSlidesService>(() => new VideoSlidesService(this))
    get videoSlides(): IVideoSlidesService {
        return this._videoSlides.value;
    }


    private _gamblingSession = new Lazy<IGamblingSessionService>(() => new GamblingSessionService(this))
    get gamblingSession(): IGamblingSessionService {
        return this._gamblingSession.value;
    }

    private _openSessions = new LazyAsync<IGamesOpenSessionService>(async () => {
        const {GamesOpenSessionService} = await import(/*webpackChunkName: "service-open-sessions" */ "./games-open-sessions/games-open-session.service");
        return new GamesOpenSessionService(this);
    });

    get openSessions(): Promise<IGamesOpenSessionService> {
        return this._openSessions.value;
    }

    private _video = new Lazy<IVideoService>(() => new VideoService(this))
    get video(): IVideoService {
        return this._video.value;
    }

    private _jackpotBet = new Lazy<IJackpotBetsService>(() => new JackpotBetsService(this))
    get jackpotBet(): IJackpotBetsService {
        return this._jackpotBet.value;
    }

    private _clientSettings = new Lazy<IClientSettingsService>(() => new ClientSettingsService(this));
    get clientSettings(): IClientSettingsService {
        return this._clientSettings.value;
    }

    private _application = new Lazy<IApplicationService>(() => new ApplicationService(this))
    get application(): IApplicationService {
        return this._application.value;
    }

    private _crypto = new Lazy<ICryptoService>(() => new CryptoService())
    get crypto(): ICryptoService {
        return this._crypto.value;
    }

    private _tabsNavigation = new Lazy<ITabsNavigationService>(() => new TabsNavigationService(this, this.menuItemActionFactory));
    get tabsNavigation(): ITabsNavigationService {
        return this._tabsNavigation.value;
    }
    private _bonusAbuseMoneyParking: Lazy<BonusAbuseMoneyParkingService> = new Lazy<BonusAbuseMoneyParkingService>(() => new BonusAbuseMoneyParkingService(this));

    private _aiRecommendationsReader = new Lazy<IAiRecommendationsReaderService>(() => new AiRecommendationsReaderService(this))
    get aiRecommendationsReader(): IAiRecommendationsReaderService {
        return this._aiRecommendationsReader.value;
    }

    private _magic8Ball = new Lazy<Magic8BallService>(() => new Magic8BallService(this));
    get magic8ball(): IMagic8BallService {
        return this._magic8Ball.value;
    }
}

